import { defineComponent as _defineComponent } from 'vue'

    const __default__ = {
        model: {
            prop: 'modelValue',
            event: 'update:modelValue',
        },
    };

import { useViewport } from '@travelata-libs/utils';
    import { computed, watch } from 'vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';
    import { MIR_CASHBACK_TEXT, hasNonMirCashbackOperators } from '../../lib/filterByMirCashback';
    import MirCashbackBadge from './MirCashbackBadge.vue';

    enum MirCashbackFilterVariant {
        Filter = 'filter',
        FilterSecondary = 'filter-secondary',
        Checkbox = 'checkbox',
    }

    interface MirCashbackFilterProps {
        modelValue?: boolean;
        value?: boolean;
        isHovered?: boolean;
        variant?: `${MirCashbackFilterVariant}`;
        selectedOperators?: number[];
        autoShowTooltip?: boolean;
    }

    interface MirCashbackFilterEmits {
        (e: 'input', value: boolean): void;
        (e: 'update:modelValue', value: boolean): void;
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MirCashbackFilter',
  props: {
    modelValue: { type: Boolean, default: false },
    value: { type: Boolean, default: false },
    isHovered: { type: Boolean, default: false },
    variant: { default: 'filter' },
    selectedOperators: { default: () => [] },
    autoShowTooltip: { type: Boolean, default: false }
  },
  emits: ["input", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'input', value: boolean): void;
        (e: 'update:modelValue', value: boolean): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, value: boolean, isHovered: boolean, variant: `${MirCashbackFilterVariant}`, selectedOperators: number[], autoShowTooltip: boolean }

    

    

    const { isMobile } = useViewport();

    const isSelected = computed({
        get: () => props.modelValue !== undefined ? props.modelValue : props.value,
        set: (v: boolean) => {
            emit('input', v);
            emit('update:modelValue', v);
        },
    });

    const badgeOptionsMap = {
        [MirCashbackFilterVariant.Filter]: {
            iconVariant: 'green',
        },
        [MirCashbackFilterVariant.FilterSecondary]: {
            iconVariant: 'light-green',
        },
        [MirCashbackFilterVariant.Checkbox]: {
            iconVariant: 'none',
            tooltipIcon: 'mir',
        },
    };

    const badgeOptions = computed(() => ({
        ...badgeOptionsMap[props.variant],
        autoShowTooltip: props.autoShowTooltip,
    }));

    const isDisabled = computed(() => hasNonMirCashbackOperators(props.selectedOperators));

    watch(
        isDisabled,
        (value) => {
            if (value) {
                emit('input', false);
                emit('update:modelValue', false);
            }
        },
        { immediate: true },
    );

    const useFilterListItem = computed(() => props.variant === 'filter');

return { __sfc: true,MirCashbackFilterVariant, props, emit, isMobile, isSelected, badgeOptionsMap, badgeOptions, isDisabled, useFilterListItem, CheckBoxInput, TextCommon, MIR_CASHBACK_TEXT, MirCashbackBadge }
}

})